import request from './axios'
import { API_ENDPOINTS } from './constants'

export const getProfessional = async () => {
  const response = await request
    .get(API_ENDPOINTS.professional)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
